import type { QueryClient } from "@tanstack/react-query";
import { axiosInstance } from "./utils/axiosInterceptor";
export function installGoalCacheRefresh(client: QueryClient) {
  const interceptor = axiosInstance.interceptors.response.use((response) => {
    const method = response.config.method?.toLowerCase();
    const path = response.config.url ?? "";
    if (method && !["get", "head", "options"].includes(method)) {
      const exerciseChanged = /(?:^|\/)exercise(?:\/|$)/.test(path);
      if (
        exerciseChanged ||
        /(?:^|\/)(goals|workouts|content|sets|bodyweights)(?:\/|$)/.test(path)
      ) {
        void client.invalidateQueries({ queryKey: ["goals"] });
      }
      if (exerciseChanged) {
        void client.invalidateQueries({ queryKey: ["goal-exercises"] });
      }
    }
    return response;
  });
  return () => axiosInstance.interceptors.response.eject(interceptor);
}
